import { BulkActionsVariant, BulkEntityActionItem } from "components/BulkActions/types";
import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";

export enum AiIntegrationsBulkActions {
  Enable = "Enable",
  Disable = "Disable",
}

export type AiIntegrationsBulkActionsAnalyticsPayload = {
  view: BulkActionsVariant;
  metadata: Record<string, string | boolean>;
};

export type AiIntegrationsMutationVariables = null;

export type AiIntegrationsBulkActionItem = BulkEntityActionItem<
  AiIntegrationsBulkActions,
  AiIntegrationView,
  AiIntegrationsMutationVariables
>;

export type AiIntegrationsBulkActionsConfirmActionStepProps = {
  bulkActionsVariant: BulkActionsVariant;
  onConfirm: (
    mutationVariables: AiIntegrationsMutationVariables,
    analyticsPayload: AiIntegrationsBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
  action: AiIntegrationsBulkActionItem;
};
